import { render, staticRenderFns } from "./Chip.vue?vue&type=template&id=778f7530"
import script from "./Chip.vue?vue&type=script&lang=js"
export * from "./Chip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports